import { Injectable, ViewContainerRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { MbConstants } from '../mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbSpinnerService {

  viewContainerRef: ViewContainerRef | undefined
  constants = MbConstants

  constructor (protected launchDialogService: LaunchDialogService) { }

  launchMbSpinner (viewContainerRef: ViewContainerRef): void {
    this.viewContainerRef = viewContainerRef
    this.launchDialogService.launch(this.constants.MB_SPINNER, this.viewContainerRef)
  }

  clearMbSpinner (): void {
    this.launchDialogService.clear(this.constants.MB_SPINNER)
    this.viewContainerRef?.clear()
  }
}
